

import { combineReducers } from '@reduxjs/toolkit';
import aft from './aftReducer';
import common from './commonReducer';
import credential from './credentialReducer';
import provision from './provisionReducer';
import stateFile from './stateFileReducer';
import users from './userReducer';
import analytics from './analyticsReducer'

const rootReducer = combineReducers({
    aft,
    common,
    credential,
    provision,
    stateFile,
    users,
    analytics
});

export default rootReducer;
